export enum WorkflowNodeTypeEnums {
    UPLOADFILE = "FILE-UPLOAD",
    OCR = "OCR",
    PARSE = "FILE-PARSE",
    LLM = "LLM",
    DATABASE = "FILE-DATABASE",
    WEBHOOK = "WEBHOOK",
    HTTP = "HTTP",
    PDF = "PDF",
    ONEDRIVEUPLOAD = "ONEDRIVEUPLOAD",
    IFELSE = "IF-ELSE",
    ERRORCATCHER = "ERROR-CATCHER",
    SCHEDULE = "SCHEDULE",
}

// Helper function to map UI node types to enum values
export const getNodeTypeEnum = (uiNodeType: string): string => {
    const nodeTypeMap: Record<string, WorkflowNodeTypeEnums> = {
        "document-upload": WorkflowNodeTypeEnums.UPLOADFILE,
        "ocr-processing": WorkflowNodeTypeEnums.OCR,
        "parsing": WorkflowNodeTypeEnums.PARSE,
        "llm-helper": WorkflowNodeTypeEnums.LLM,
        "document-store": WorkflowNodeTypeEnums.DATABASE,
        "mongodb": WorkflowNodeTypeEnums.DATABASE,
        "webhook": WorkflowNodeTypeEnums.WEBHOOK,
        "HTTP": WorkflowNodeTypeEnums.HTTP,
        "pdf-generator": WorkflowNodeTypeEnums.PDF,
        "onedrive-upload": WorkflowNodeTypeEnums.ONEDRIVEUPLOAD,
        "if-else": WorkflowNodeTypeEnums.IFELSE,
        "schedule": WorkflowNodeTypeEnums.SCHEDULE,
        "SCHEDULE": WorkflowNodeTypeEnums.SCHEDULE,
    };

    return nodeTypeMap[uiNodeType] || uiNodeType;
};
